const decodeEntities = (function () {
  // this prevents any overhead from creating the object each time
  var element = document.createElement("div");

  function decodeHTMLEntities(str) {
    if (str && typeof str === "string") {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = "";
    }

    return str;
  }

  return decodeHTMLEntities;
})();

const dateFormat = (function () {
  const token =
      /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
    timezone =
      /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
    timezoneClip = /[^-+\dA-Z]/g,
    pad = function (val, len) {
      val = String(val);
      len = len || 2;
      while (val.length < len) val = "0" + val;
      return val;
    };

  return function (date, mask, utc) {
    const dF = dateFormat;

    if (
      arguments.length === 1 &&
      Object.prototype.toString.call(date) === "[object String]" &&
      !/\d/.test(date)
    ) {
      mask = date;
      date = undefined;
    }

    date = date ? new Date(date) : new Date();
    if (isNaN(date)) throw SyntaxError("invalid date");

    mask = String(dF.masks[mask] || mask || dF.masks["default"]);

    if (mask.slice(0, 4) === "UTC:") {
      mask = mask.slice(4);
      utc = true;
    }

    const _ = utc ? "getUTC" : "get",
      d = date[_ + "Date"](),
      D = date[_ + "Day"](),
      m = date[_ + "Month"](),
      y = date[_ + "FullYear"](),
      H = date[_ + "Hours"](),
      M = date[_ + "Minutes"](),
      s = date[_ + "Seconds"](),
      L = date[_ + "Milliseconds"](),
      o = utc ? 0 : date.getTimezoneOffset(),
      flags = {
        d: d,
        dd: pad(d),
        ddd: dF.i18n.dayNames[D],
        dddd: dF.i18n.dayNames[D + 7],
        m: m + 1,
        mm: pad(m + 1),
        mmm: dF.i18n.monthNames[m],
        mmmm: dF.i18n.monthNames[m + 12],
        yy: String(y).slice(2),
        yyyy: y,
        h: H % 12 || 12,
        hh: pad(H % 12 || 12),
        H: H,
        HH: pad(H),
        M: M,
        MM: pad(M),
        s: s,
        ss: pad(s),
        l: pad(L, 3),
        L: pad(L > 99 ? Math.round(L / 10) : L),
        t: H < 12 ? "a" : "p",
        tt: H < 12 ? "am" : "pm",
        T: H < 12 ? "A" : "P",
        TT: H < 12 ? "AM" : "PM",
        Z: utc
          ? "UTC"
          : (String(date).match(timezone) || [""])
              .pop()
              .replace(timezoneClip, ""),
        o:
          (o > 0 ? "-" : "+") +
          pad(Math.floor(Math.abs(o) / 60) * 100 + (Math.abs(o) % 60), 4),
        S: ["th", "st", "nd", "rd"][
          d % 10 > 3 ? 0 : (((d % 100) - (d % 10) !== 10) * d) % 10
        ],
      };

    return mask.replace(token, function ($0) {
      return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
    });
  };
})();

dateFormat.masks = {
  default: "ddd mmm dd yyyy HH:MM:ss",
  shortDate: "m/d/yy",
  mediumDate: "mmm d, yyyy",
  longDate: "mmmm d, yyyy",
  fullDate: "dddd, mmmm d, yyyy",
  shortTime: "h:MM TT",
  mediumTime: "h:MM:ss TT",
  longTime: "h:MM:ss TT Z",
  isoDate: "yyyy-mm-dd",
  isoTime: "HH:MM:ss",
  isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
  isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
};

dateFormat.i18n = {
  dayNames: [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  monthNames: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

Date.prototype.format = function (mask, utc = false) {
  console.log(utc);
  return dateFormat(this, mask, utc);
};

Date.prototype.fromString = function (date) {
  const regular = new RegExp(
    /(?<Year>\d{4})-(?<Month>\d{2})\-(?<Day>\d{2})(?: (?<Hours>\d{2})\:(?<Minutes>\d{2})(?:\:(?<Seconds>\d{2}))?)?/
  );
  const matches = regular.exec(date);
  const currentDate = new Date();
console.log(matches)
  return new Date(
            parseInt(matches?.groups?.Year) || currentDate.getFullYear(),
            (parseInt(matches?.groups?.Month) - 1) || currentDate.getMonth(),
            parseInt(matches?.groups?.Day) || currentDate.getDay(),
            parseInt(matches?.groups?.Hours) || currentDate.getHours(),
            parseInt(matches?.groups?.Minutes) || currentDate.getMinutes(),
            parseInt(matches?.groups?.Seconds) || currentDate.getSeconds(),
        );
};

class LogicTemplate {
  constructor() {
    this.inspections = [
      /* IF ELSE */
      /\[\[\sif\s(?<Statement>[^\]]+?)\s\]\](?<Success>((?!\[\[\selse\s\]\])(?!\[\[\sendif\s\]\])(?!\[\[\sif).)*)\[\[\selse\s\]\](?<Rejected>((?!\[\[\selse\s\]\])(?!\[\[\sendif\s\]\])(?!\[\[\sif).)*)\[\[\sendif\s\]\]/gms,
      /* IF */
      /\[\[\sif(?<Statement>[^\]]+?)\s\]\](?<Success>((?!\[\[\selse\s\]\])(?!\[\[\sendif\s\]\])(?!\[\[\sif).)*)\[\[\sendif\s\]\]/gms,
    ];
    this.variables = [
      /* With search */
      /\[\[\s(?<Fields>[^\]]+?)\s(?<Confirmation>[^\]]+?)\s"(?<Value>.+?)"\s\|\s(?<ShowFields>.+?)\s\]\]/gm,
      /* Without search */
      /\[\[\s(?<Fields>.+?)\s\]\]/gms,
    ];
  }

  dateDiffToString(a, b) {
    let diff = Math.abs(a - b);

    let ms = diff % 1000;
    diff = (diff - ms) / 1000;
    let ss = diff % 60;
    diff = (diff - ss) / 60;
    let mm = diff % 60;
    diff = (diff - mm) / 60;
    let hh = diff % 24;
    let days = (diff - hh) / 24;

    let format = "";

    if (days > 0) {
      format += " " + days.toString() + " days";
    }
    if (hh > 0) {
      format += " " + hh.toString() + " hrs.";
    }
    if (mm > 0) {
      format += " " + mm.toString() + " min.";
    }

    return format;
  }

  /**
   * Parse variables
   *
   * @param {string} string
   * @param {Object} variables
   * @returns {string}
   */
  parseVariables(string, variables = {}) {
            let m;
            for (const regular of this.variables) {
                for (let i = 0; i < 2; i++) {
                    while ((m = regular.exec(string)) !== null) {
                        let replacement = "";
                        let field = null;
                        if (m.index === regular.lastIndex) {
                            regular.lastIndex++;
                        }
                        if (
                            m.groups.Fields &&
                            m.groups.Confirmation &&
                            m.groups.Value &&
                            m.groups.ShowFields
                        ) {
                            field = this.parseFields(
                                m.groups.Fields.split("."),
                                m.groups.Value,
                                m.groups.Confirmation,
                                variables
                            );
                            if (field.length > 0) {
                                field = field[0];
                                replacement = this.showField(m.groups.ShowFields, field);
                            }
                        } else if (m.groups.Fields) {
                            // replacement = this.showField(m.groups.Fields, variables);
                            replacement = null
                        }
                        if (replacement) string = string.replace(m[0], replacement);
                    }
                }
                while ((m = regular.exec(string)) !== null) {
                    let replacement = "";
                    if (m.index === regular.lastIndex) {
                        regular.lastIndex++;
                    }

                    if (m.groups.Fields) {
                        replacement = this.showField(m.groups.Fields, variables);
                    }

                    if (replacement) string = string.replace(m[0], replacement);
                }
            }

            for (const regular of this.variables) {
                if (string.match(regular)) {
                    string = this.parseVariables(string, variables)
                }
            }

            return string;
        }

  additionalFieldLogic(value, logic) {
    let explode = logic.split(":").map((item) => {
      return item.replace(/"/gm, "").trim();
    });

    if (explode[0]) {
      switch (explode[0]) {
        case "format":
          if (explode[1]) {
            try {
              value = new Date().fromString(value).format(explode[1]);
            } catch (e) {
              console.warn(e.toString());
            }
          }
          break;

        case "countdown":
          try {
            // value = this.dateDiffToString(new Date(value), new Date());
            value = this.dateDiffToString(new Date(value), new Date());
          } catch (e) {
            console.warn(e.toString());
          }
          break;
      }
    }
    return value;
  }

  /**
   * Show fields
   *
   * @param fieldsPath
   * @param value
   * @returns {string|*}
   */
  showField(fieldsPath, value) {
    let field = value;
    let paths = fieldsPath.split(" | ");
    fieldsPath = paths.shift().split(".");

    for (const key of fieldsPath) {
      if (field[key]) {
        field = field[key];
      } else {
        field = "";
      }
    }

    if (paths.length > 0) {
      for (const logic of paths) {
        field = this.additionalFieldLogic(field, logic);
      }
    }

    if (field) {
      return field.toString();
    }

    return "";
  }

  getCompare(a, compare, b) {
    switch (compare) {
      case "==":
        return a == b;
      case "<>":
      case "!=":
        return a != b;
      case "<":
        return a < b;
      case ">":
        return a > b;
      default:
        throw new Error("Unknown Confirmation");
    }
  }

  /**
   * Parse fields from variables
   *
   * @param {Array} fieldsPath
   * @param {String} Value
   * @param {String} confirmation
   * @param {Object} variables
   * @param {Array} additionalStatements
   * @returns {*}
   */
  parseFields(
    fieldsPath,
    Value,
    confirmation,
    variables,
    additionalStatements = []
  ) {
    let field = variables;
    let key;
    while ((key = fieldsPath.shift())) {
      if (field[key]) {
        field = field[key];
      } else {
        fieldsPath.unshift(key);
        break;
      }
    }

    if (Array.isArray(field)) {
      field = field.filter((item) => {
        let verify = item;
        for (const key of fieldsPath) {
          if (verify[key]) verify = verify[key];
          else return false;
        }
        return this.getCompare(verify, confirmation, Value);
      });

      if (additionalStatements.length) {
        for (let additionalStatement of additionalStatements) {
          additionalStatement = additionalStatement
            .split(" ")
            .filter(function (item) {
              return item.length > 0;
            });
          if (additionalStatement.length === 3) {
            field = field.filter((item) => {
              const isDate = /(\d{4})-(\d{2})-(\d{2})/;
              let verify = this.parseFields(
                additionalStatement[0].split("."),
                additionalStatement[2],
                additionalStatement[1],
                item
              );
              let val = additionalStatement[2];

              if (isDate.exec(verify)) verify = new Date(verify);
              if (isDate.exec(val)) val = new Date(val);

              return this.getCompare(verify, additionalStatement[1], val);
            });
          }
        }
      }
    }

    return field;
  }

  /**
   * Parse logic statement
   *
   * @param {string} statement
   * @param {Object} variables
   * @returns {boolean}
   */
  parseLogicStatement(statement, variables = {}) {
    let additionalStatements = statement.split("|").map((item) => item.trim());
    statement = additionalStatements.shift();
    const regular = new RegExp(
      /(?<Fields>.+?)\s(?<Confirmation>.+?)\s"(?<Value>.+?)"/,
      "gm"
    );
    let m;
    if ((m = regular.exec(statement)) !== null) {
      let fieldsPath = m.groups.Fields.split(".");
      let field = this.parseFields(
        fieldsPath,
        m.groups.Value,
        m.groups.Confirmation,
        variables,
        additionalStatements
      );

      if (Array.isArray(field)) {
        return field.length > 0;
      }

      return this.getCompare(field, m.groups.Confirmation, m.groups.Value);
    }
    return false;
  }

  /**
   * Parse if else statement
   *
   * @param {string} statement
   * @param {string} success
   * @param {string} rejected
   * @param {Object} variables
   * @returns {string}
   */
  parseIfElse(statement, success, rejected, variables = {}) {
    if (this.parseLogicStatement(statement, variables)) {
      return this.parseInspections(success, variables);
    }
    return this.parseInspections(rejected, variables);
  }

  /**
   * Parse if statement
   *
   * @param {string} statement
   * @param {string} success
   * @param {Object} variables
   * @returns {string}
   */
  parseIf(statement, success, variables = {}) {
    return this.parseLogicStatement(statement, variables)
      ? this.parseInspections(success, variables)
      : "";
  }

  parseInspections(string, variables = {}) {
    let m;
    string = string.trim();
    for (const regular of this.inspections) {
      while ((m = regular.exec(string)) !== null) {
        if (m.groups.Statement && m.groups.Rejected && m.groups.Success) {
          string = string.replace(
            m[0],
            this.parseIfElse(
              m.groups.Statement,
              m.groups.Success,
              m.groups.Rejected,
              variables
            )
          );
        } else if (m.groups.Statement && m.groups.Success) {
          string = string.replace(
            m[0],
            this.parseIf(m.groups.Statement, m.groups.Success, variables)
          );
        }
      }
    }
    return string.trim();
  }

  /**
   * Template
   *
   * @param {string} string
   * @param {Object} variables
   * @returns {string}
   */
  template(string, variables = {}) {
    console.table({string, variables})
    string = this.parseInspections(string, variables);
    string = this.parseVariables(string, variables);

    return string.toString();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const CACHE_MINUTES = 10;
  let json = {
    method: "ip",
    order: {
      weight: {
        value: "0.01",
        units: "LBS",
      },
      total_amount: {
        amount: 1,
        currency: "USD",
      },
    },
  };

  const template = new LogicTemplate();

  function renderElement(el, variables = {}) {
    if (!el) return;
    const message = el.querySelector(".announcement-bar__message.text");
    const preload = el.querySelector(".announcement-bar__message.preload_text");

    if (preload) {
      preload.style.display = "none";
    }

    if (message) {
      message.innerHTML = template.template(
        decodeEntities(message.innerHTML),
        variables
      );
      message.style.display = "block";
    }
  }

  const LogicTemplateExpire =
    parseInt(localStorage.getItem("LogicTemplateExpire")) || 0;
  const isExpired = LogicTemplateExpire < new Date().getTime();
  let LogicTemplateVariables =
    JSON.parse(localStorage.getItem("LogicTemplateVariables")) || {};

  if (localStorage.getItem("LogicTemplateVariables") && !isExpired) {
    for (const el of document.querySelectorAll(
      '[data-logic-template="cache"]'
    )) {
      renderElement(el, LogicTemplateVariables);
    }
  }

  fetch("/apps/crystal-settings/api/v1/delivery/", {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(json),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (response) {
      if (!localStorage.getItem("LogicTemplateVariables") || isExpired) {
        localStorage.setItem(
          "LogicTemplateExpire",
          (new Date().getTime() + CACHE_MINUTES * 60000).toString()
        );
        localStorage.setItem(
          "LogicTemplateVariables",
          JSON.stringify(response)
        );
        LogicTemplateVariables = response;
        for (const el of document.querySelectorAll(
          '[data-logic-template="cache"]'
        )) {
          renderElement(el, response);
        }
      }

      for (const el of document.querySelectorAll(
        '[data-logic-template="include"]'
      )) {
        renderElement(el, LogicTemplateVariables);
      }
    });

  document.addEventListener("LigicTemplate:AnnouncementBar", function () {
    for (const el of document.querySelectorAll(
      '[data-logic-template="include"]'
    )) {
      renderElement(el, LogicTemplateVariables);
    }
    for (const el of document.querySelectorAll(
      '[data-logic-template="cache"]'
    )) {
      renderElement(el, LogicTemplateVariables);
    }
  });

  function waitForElm(selector) {
    if (document.querySelector(selector)) {
      document.dispatchEvent(new CustomEvent("LigicTemplate:AnnouncementBar"));
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (!mutation.addedNodes) return;

        for (let i = 0; i < mutation.addedNodes.length; i++) {
          let node = mutation.addedNodes[i];
          if (node && node.outerHTML && node.outerHTML.match(/announce/)) {
            document.dispatchEvent(
              new CustomEvent("LigicTemplate:AnnouncementBar")
            );
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  waitForElm("#shopify-section-announcement-bar[data-shopify-editor-section]");
});
